<template>
    <ResultCardContainer :header-title="t('results.chipDistribution.cardTitle')">
        <FlexContainer
            :flex-direction="flexDirection.column"
        >
          <Typography
              :variant="typographyVariants.label"
              :weight="typographyWeights.regular"
              :color="typographyColors.greyMedium"
          >
            {{ t('results.chipDistribution.table.caption') }}
          </Typography>
          <SpacingClassWrapper
              :padding-top="1"
          >
            <Typography
                :variant="typographyVariants.body"
                :weight="typographyWeights.regular"
                :color="typographyColors.dark"
                :size="typographySizes.title"
            >
              {{ $options.filters.withCommas(formFieldsData.numberOfChips.submittedValue) }}
            </Typography>
          </SpacingClassWrapper>
        </FlexContainer>
        <SpacingClassWrapper
            :padding-right="0"
            :margin-top="$mq | mq({ sm: 6, md: 6, pccFullSize: 4 })"
        >
            <TableScrollContainer
                :table-height-px="$mq | mq({
                    sm: 370,
                    md: 310
                })"
                :table-headers="tableHeaders"
                :table-headers-align="tableCellAlign.left"
                :scroll-visibility="scrollbarApperance.visible"
                :class="chipDistributionTableClasses"
            >
                <tr
                    v-for="(item, index) in chipDistribution"
                    :key="index"
                >
                    <SpacingClassWrapper 
                        :padding-bottom="lastChipElement(index) ? 0 : 4"
                        :padding-top="0"
                    >
                        <TableCell
                            :variant="tableCellVariants.standard"
                            :text-align="tableCellAlign.left"
                        >
                            <Typography
                                :size="typographySizes.caption"
                                :weight="typographyWeights.bold"
                                :transform="typographyTransform.capitalize"
                                :color="typographyColors.dark"
                            >
                                {{ item.color }}
                            </Typography>
                        </TableCell>
                        <SpacingClassWrapper :padding="0">
                            <TableCell
                                :variant="tableCellVariants.standard"
                                :text-align="tableCellAlign.center"
                            >
                                <Typography
                                    :variant="typographyVariants.caption"
                                    :weight="typographyWeights.regular"
                                    :color="typographyColors.dark"
                                >
                                    {{ item.value }}
                                </Typography>
                            </TableCell>
                            <TableCell
                                :variant="tableCellVariants.standard"
                                :text-align="tableCellAlign.center"
                            >
                                <Typography
                                    :variant="typographyVariants.caption"
                                    :weight="typographyWeights.regular"
                                    :color="typographyColors.dark"
                                >
                                    {{ item.eachPlayer }}
                                </Typography>
                            </TableCell>
                            <TableCell
                                :variant="tableCellVariants.standard"
                                :text-align="tableCellAlign.center"
                            >
                                <SpacingClassWrapper :padding-left="1">
                                    <Typography
                                        :variant="typographyVariants.caption"
                                        :weight="typographyWeights.bold"
                                        :color="typographyColors.dark"
                                    >
                                        {{ item.quantity }}
                                    </Typography>
                                </SpacingClassWrapper>
                            </TableCell>
                        </SpacingClassWrapper>
                    </SpacingClassWrapper>
                </tr>
            </TableScrollContainer>
        </SpacingClassWrapper>
    </ResultCardContainer>
</template>

<script>
// Components
import Typography from '../../components/Typography';
import TableCell from '../../components/TableCell';

// Class Wrappers
import SpacingClassWrapper from '../../classWrappers/SpacingClassWrapper';

// Containers
import ResultCardContainer from '../../containers/results/ResultCardContainer';
import TableScrollContainer from '../../containers/generic/TableScrollContainer';
import FlexContainer from '../../containers/flex/FlexContainer';

// Types
import {
    typographyVariants,
    typographyColors,
    typographyWeights,
    typographyTransform,
    typographySizes
} from '../../types/Typography.types';
import { flexDirection, flexWrap } from '../../types/Flex.types';
import { scrollbarApperance, scrollbarApperanceDefault } from '../../types/ScrollFlex.types';
import { tableCellVariants, tableCellAlign } from '../../types/TableCell.types'

// Mixins
import styles from '../../mixins/styles.js';
import translations from '../../mixins/translations.js';

// Vuex
import { createNamespacedHelpers } from 'vuex';
const { mapGetters, mapState } = createNamespacedHelpers('pokerChipCalcModule');

export default {
    name: 'ChipDistributionLayout',
    components: {
        // Components
        Typography,
        TableCell,
        // Class Wrappers
        SpacingClassWrapper,
        // Containers
        ResultCardContainer,
        TableScrollContainer,
        FlexContainer
    },
    mixins: [styles, translations],
    data: function () {
        return {
            typographyVariants,
            typographyColors,
            typographyWeights,
            typographyTransform,
            typographySizes,
            flexDirection,
            flexWrap,
            scrollbarApperance,
            tableCellVariants,
            tableCellAlign
        }
    },
    computed: {
        ...mapState([
            'formFieldsData',
        ]),
        ...mapGetters([
            'chipDistribution',
        ]),
        tableHeaders: function() {
            return [
                this.t('results.chipDistribution.table.headers.color'),
                this.t('results.chipDistribution.table.headers.value'),
                this.t('results.chipDistribution.table.headers.each'),
                this.t('results.chipDistribution.table.headers.quantity'),
            ]
        },
        chipDistributionTableClasses: function () {
            return [
                this.cssClasses.pcc__chipDistribution__table
            ];
        }
    },
    methods: {
        lastChipElement: function(currentIndex) {
            return this.chipDistribution.length === currentIndex + 1;
        }
    }
};
</script>
